import "./styles.sass";
import ReactDOM from "react-dom";
import { useRef, useState, useEffect } from "react";
import assets from "../../assets";

export const Popup = ({ isOpen, onClose, children, wrapperClass = "", hideClose = false, isLoading = false }) => {
  const scrollRef = useRef(null);

  const [showUp, setShowUp] = useState(false);
  const [showDown, setShowDown] = useState(false);

  const checkScroll = () => {
  const el = scrollRef.current;
  if (!el) return;

  const isScrollable = el.scrollHeight - el.clientHeight > 5;

  if (!isScrollable) {
    setShowUp(false);
    setShowDown(false);
    return;
  }

  setShowUp(el.scrollTop > 5);
  setShowDown(el.scrollTop + el.clientHeight < el.scrollHeight - 5);
};

  const scroll = (dir) => {
    const el = scrollRef.current;
    if (!el) return;

    const scrollAmount = 300;

    el.scrollBy({
      top: dir === "up" ? -scrollAmount : scrollAmount,
    });
  };

  useEffect(() => {
    checkScroll();
  }, [children, isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="popup-overlay" onClick={onClose}>
      <div
        className={`popup-content-neet ${wrapperClass}`}
        onClick={(e) => e.stopPropagation()}
      >
        {!hideClose && <img src={assets.ic_close} className="close-btn" onClick={onClose} />}
        
        {isLoading && (
          <div className="popup_loader_overlay">
            <div className="spinner"></div>
          </div>
        )}


        <div className="vertical-wrapper">
          {/* 🔼 show only when needed */}
          {showUp && (
            <button className="scroll-btn up" onClick={() => scroll("up")}>
              ▲
            </button>
          )}

          <div
            className="scroll-container"
            ref={scrollRef}
            onScroll={checkScroll} // 👈 track scrolling
          >
            {children}
          </div>

          {/* 🔽 show only when needed */}
          {showDown && (
            <button className="scroll-btn down" onClick={() => scroll("down")}>
              ▼
            </button>
          )}
        </div>
      </div>
    </div>,
    document.getElementById("popup"),
  );
};
